<template>
    <!-- 首页 登录框/用户信息展示【登录状态】 author: zhangxiaofeng-->
    <div class="login-box">
      <!-- 网易易盾 -->
      <div  ref="captcha"></div>
      <!-- 已登录、用户信息展示 -->
      <div v-if="user.userType" class="info-card" :class="{'reset-margin-top': resetMarginTop}">
        <div class="portrait-wrapper">
          <img :src="'https://account.glodon.com/avatar/show/' + user.gldUserId + '/32'" alt="头像">
        </div>
        <p class="user-name">
          {{user.userName}}
        </p>
        <div class="progress-cont">
          <!-- 管理员不显示空间容量 进度条 -->
          <div class="progress-box" v-if="+user.userType !== 3">
            <span :style="{width: percentage + '%', background: percentage >= 80 ? 'rgb(255, 8, 43)' : 'rgb(68, 255, 68)'}"></span>
          </div>
          <div class="user-space-des">
            <span>{{userSpaceDes.title}}</span>（
            <em>{{userSpaceDes.capacity}}</em>）
          </div>
        </div>
        <!--<button type="button" @click="goPage(user.userType, true)">进入造价云管理平台</button>-->
        <!--<button type="button" @click="accountLogout()" class="gray">退出</button>-->
        <button class="w__button common-button w__button--primary w__button--size-small" type="button" @click="goPage(user.userType, true)">进入造价云管理平台</button>
        <button type="button" @click="accountLogout()" class="w__button w__button--minor w__button--size-small gray">退出</button>
      </div>
      <div v-else-if="form.mobileSucceed" class="form accont-form-box" :class="{'reset-margin-top': resetMarginTop}">
        <div class="login-close-div" @click.stop = "$emit('changeLoginShow',false)" />
        <i class="r2-icon-nav_close login-close"></i>
        <p class="title"><em class="r2-icon-hardware_keyboard_backspace_outlined float_left cusor-pointer" style="font-size: 24px;opacity: 0.55;" @click="form.mobileSucceed=false"></em> 已关联账号</p>
        <template v-if="form.list.length>0">
          <p class="tip">下方为已关联的账号，可直接进入</p>
          <div class="content" v-loading="mobileLoginLoading">
            <!--<w-scrollbar wrap-style="overflow-x: hidden;" native noresize style="height: 320px;overflow-x: hidden;">-->
              <div class="content-item" v-for="item of form.list" @click="mobileLogin(item)">
                <div class='item-left' :class="item.enterpriseId?'':'person'">
                  <span :class="item.enterpriseId?'r2-icon-cmc_business':'r2-icon-social_person'"></span>
                </div>
                <div class='item-right'>
                  <div class="item-title">{{item.enterpriseId?item.enterpriseName:'个人账号'}}</div>
                  <div class="item-account">
                  <span class="item-name">
                    <template v-if="item.enterpriseId">{{item.roleName}} </template>
                    {{item.fullname}}
                  </span>
                  </div>
                </div>
                <div style="width: 56px;padding-left: 12px;padding-right: 12px;">
                  <w-button type="primary" size="small" style="height: 28px;margin-top: 19px;font-size: 14px;">进入</w-button>
                </div>
              </div>
            <!--</w-scrollbar>-->
          </div>
        </template>
        <template v-else>
          <div style="minHeight: 350px;" v-loading="fetchingMobile">
            <template v-if="!fetchingMobile">
              <div class="common-txt">您的手机号 +86 {{form.mobile}} </br> 未关联任何广联达账号
              </div>
              <div class="common-button-box">
                <w-button type="primary" @click="signMobile" class="common-button">
                  注册手机号为账号并登录
                </w-button>
                <w-button type="minor" @click="toggleLoginType=!toggleLoginType" class="common-button">
                  使用账号登录
                </w-button>
              </div>
            </template>
          </div>
        </template>
      </div>
      <!-- 未登录状态 用户名密码输入款 -->
      <form class="form" :class="{'reset-margin-top': resetMarginTop}" v-if="!form.mobileSucceed && !isDoubleVerify && !user.userType" action="javascript: void(0);" @submit="submitForm" v-loading="fetchingMobile">
        <!-- 为了让关闭好点些增加一个遮盖 -->
        <div class="login-close-div" @click.stop = "$emit('changeLoginShow',false)" />

        <i class="r2-icon-nav_close login-close"></i>
        <p class="title">
          欢迎使用造价云管理平台
        </p>
        <div class="form-item--cont" style="position: relative;">
          <p key="1" class="input--wrapper"  style="position: absolute; top: 10; left: 32px; zIndex: 1; width: calc(100% - 64px);" :style="{opacity: toggleLoginType?1:0}">
            <input autocomplete="on" v-model="form.userName" name="userName" type="text" placeholder="手机、邮箱、用户名" @click="loginError = ''">
            <i class="r2-icon-social_person"></i>
          </p>
          <p key="2" v-show="!toggleLoginType" class="phone-number-wrapper"  style="position: absolute; top: 10; left: 32px; zIndex: 10; width: calc(100% - 64px);">
            <w-select v-model="form.areaCode" class="input-area-member" slot="prepend" placeholder="请选择">
              <w-option label="+86" value="+86"></w-option>
            </w-select>
            <!--input autoComplete="new-password" type="password" hidden-->
            <input placeholder="请输入手机号" type="tel" name="mobile" v-model="form.mobile" class="input-mobile-member">
            </input>
          </p>
          <p key="3" v-show="toggleLoginType" class="input--wrapper mg-t-24" style="marginTop: 72px;">
            <input v-model="form.password" type="password" placeholder="请输入密码" @click="loginError = ''" id="indexPagePassword">
            <i class="r2-icon-action_lock"></i>
          </p>
          <div key="4" v-show="!toggleLoginType" class="phone-number-wrapper" style="marginTop: 48px;">
            <input placeholder="6位短信验证码" v-model="form.verification" class="input-mobile-member verification-input">
            </input>
            <button type="button" class="verification-button" :class="isMobile&&form.timer==0?'':'disabled'"><Countdown :time="form.timer" @click="getVerification" @finish="form.timer=0" /></button>
          </div>
          <p key="5" class="error-tips">
            <i v-show="loginError" class="r2-icon-alert_error" style="position: relative;"></i>
            {{loginError}}
          </p>
          <button class="w__button common-button w__button--primary w__button--size-small" type="submit">
            <span>登录</span>
          </button>
          <p class="forget-link">
            <a class="float_left color_link" href="javascript:void(0);" @click="toggleLoginType=!toggleLoginType">
            {{toggleLoginType?'短信快捷登录':'账号登录'}}
            </a>
            <a class="float_right foget_password" href="https://account.glodon.com/forgetInit" @click="sentLog(100101038)" target="_blank">
              忘记密码
            </a>
          </p>
        </div>
      </form>
      <!-- <transition> -->
        <form  v-if="isDoubleVerify" class="form form2" action="javascript: void(0);" @submit="verifyCode">
          <!-- 为了让关闭好点些增加一个遮盖 -->
          <div class="login-close-div" @click.stop="closeVerify">
          <i class="r2-icon-nav_close login-close"></i>

          </div>

          <p class="title">
            <i  @click.stop="closeVerify" class="r2-icon-hardware_keyboard_backspace_outlined"></i>
            身份验证
          </p>
          <p class="describe">
            为保证企业的数据安全，请进行身份验证<br>
            验证码已发送至尾号 {{phone.slice(7)}} 的密保手机
          </p>
          <div class="form-item--cont" style="position: relative;">
          <div key="4" class="phone-number-wrapper" style="marginTop: 48px;">
              <input  :style="[{borderColor:(loginVerifyError?'#E02020':'')},{zIndex:(loginVerifyError?1:'')}]" placeholder="6位短信验证码" v-model.trim="verifyForm.verification" class="input-mobile-member verification-input">
              </input>
              <button type="button" class="verification-button" :class="!isDisabled&&verifyForm.timer==0?'':'disabled'"><Countdown :autoStart="isDisabled" :time="verifyForm.timer" @click="getDoubleVerification(phone)"  @finish="countFinis" /></button>
            </div>
            <p key="5" class="error-tips">
              <!-- <i v-show="loginVerifyError" class="r2-icon-alert_error" style="position: relative;"></i> -->
              {{loginVerifyError}}
            </p>
            <button class="w__button common-button w__button--primary w__button--size-small verifyButton" type="submit">
              <span>确定</span>
            </button>
          </div>

        </form>
      <!-- </transition> -->
      <!-- 管理员未修改初始密码 88888888 引导去修改 code: 200018 -->
      <div class="safety-dialog-bg" v-if="safetyDialogShow">
        <div class="safety-dialog">
          <a href="javascript: void(0);" class="w-icon-quxiao2 close" @click="safetyDialogClose"></a>
          <div class="safety-content">
            <p>您的密码安全等级低，请前往更改密码后登录</p>
            <!--<a class="ui-btn ui-btn_lg ui-btn_blue" @click="safetyLinkTap" >前往更改</a>-->
            <w-button type="primary" @click="safetyLinkTap">前往更改</w-button>
          </div>
        </div>
      </div>
      <div class="absolute">
        <!--<iframe :src="qydataUrl + '/integration/indexChart'" frameborder="0" width="0" height="0" style="opacity: 0;width: 0px;height: 0px;"></iframe>-->
        <iframe :src="qydataUrl + '/integration/zjyLogin'" frameborder="0" width="0" height="0" style="opacity: 0;width: 0;height: 0;"></iframe>
        <iframe :src="qydataUrl + '/zjy/charts/qyPriceMaterialSave.html'" frameborder="0" width="0" height="0" style="opacity: 0;width: 0;height: 0;"></iframe>
      </div>
    </div>
</template>
<style lang="less">
.input-area-member{
  .w__input__inner{
    height: 48px;
    border-radius: 4px 0 0 4px;
    position: relative;
    right: -1px;
    outline: 0;
    &:focus {
      outline: none;
      border-color: inherit;
      box-shadow: 0 0 0 2px rgba(24,144,255,.2);
    }
    .w__select-dropdown__item.hover, .w__select-dropdown__item:hover {
      background: #fff;
    }
  }
}
</style>
<style lang="less" type="text/less" scoped>
  .login-box{
    position: absolute;
    // width: 404px;
    // height: 0;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    // margin: 0 auto;
    z-index: 500;
    display: flex;
    justify-content: center;
    &>.form, &>.info-card{
      position: relative;
      float: right;
      width: 404px;
      margin-top: 156px;
      height: 470px;
      background:rgb(255,255,255);
      box-shadow:0px 6px 20px 0px rgba(33,37,48,0.35);
      border-radius:4px;
      &.reset-margin-top {
        margin-top: 0;
      }
      button{
        cursor: pointer;
        height:48px;
        width: 100%;
        margin-top: 19px;
        /*background:rgb(32,121,250);*/
        outline: none;
        /*border: none;*/
        /*box-shadow:0px 2px 4px 0px rgba(6,21,44,0.2);*/
        border-radius:4px;
        /*color: #fff;*/
        font-size:16px;
        font-weight:500;
      }
    }
    &>.form.accont-form-box{
      padding: 0 16px;
      /*padding-right: 0px;*/
      box-sizing: border-box;
      em {
        display: inline-block;
        padding-right: 10px;
      }
      .common-txt{
        font-size:18px;
        color:rgba(33,37,48,0.8);
        line-height:36px;
        margin: 68px 34px 24px 34px;
        text-align: center;
      }
      .common-button-box{
        margin: 0 34px;
        text-align: center;
        .common-button{
          margin: 24px 0 0 0;
        }
      }

      .title{
        text-align: left;
        margin-top: 30px;
        padding-left: 16px;
      }
      .tip{
        font-size:14px;
        line-height: 22px;
        color:rgba(33,37,48,0.55);
        padding-left: 16px;
        margin-top: 8px;
      }
      .content{
        margin-top: 20px;
        height: 320px;
        overflow-x: auto;
        /*padding-right: 8px;*/
        &::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }
        &::-webkit-scrollbar-track-piece {
          background-color: #f1f1f1;
          -webkit-border-radius: 8px;
        }
        &::-webkit-scrollbar-thumb:vertical {
          height: 8px;
          background-color: #c1c1c1;
          -webkit-border-radius: 8px;
        }
        &::-webkit-scrollbar-thumb:horizontal {
          width: 8px;
          background-color: #c1c1c1;
          -webkit-border-radius: 8px;
        }
      }
      .content-item{
        height:66px;
        border-radius:4px;
        border:1px solid rgba(33,37,48,0.15);
        margin-top: 12px;
        display: flex;
        &:first-child {
          margin-top: 0;
        }
        &:hover{
          cursor: pointer;
          border:1px solid rgba(32,121,250,1);
          box-shadow:0px 0px 0px 2px rgba(32,121,250,0.2);
        }
        .item-left{
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          margin: 12px;
          border-radius: 50%;
          background:#2079FA;
          color: #fff;
          &.person{
            background: #08CB96;
          }
          span{
            display: inline-block;
            font-size: 24px;
          }
        }
        .item-right{
          flex: 1;
          padding-right: 12px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .item-title{
          font-size:14px;
          color:rgba(33,37,48,1);
          line-height:22px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          /*max-width: 214px;*/
          /*max-width: 250px;*/
        }
        .item-account{
          font-size:12px;
          color:rgba(33,37,48,0.55);
          line-height:20px;
        }
        .item-name{
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          /*max-width: 214px;*/
          display: inline-block;
        }
      }
    }
    .info-card{
      box-sizing: border-box;
      padding: 18px 32px;
      text-align: center;
      .portrait-wrapper{
        margin: 0 auto;
        width: 85px;
        height: 85px;
        border-radius: 50%;
        border: 2px solid #0068ff;
        margin-top: 20px;
        overflow: hidden;
        img{
          width: 85px;
          height: 85px;
        }
      }
      .user-name{
        font-size: 16px;
        color: #454545;
        padding-top: 20px;
      }
      .progress-cont{
        padding-top: 20px;
        .progress-box{
          margin-top: 10px;
          height: 8px;
          border-radius: 5px;
          background: #dfdfdf;
          overflow: hidden;
          span{
            display: block;
            height: 8px;
            background: #4f4;
            border-radius: 5px;
            width: 0;
          }
        }
        .user-space-des{
          font-size: 14px;
          color: #454545;
          padding-top: 15px;
          padding-left: 10px;
        }
      }
      button{
        margin-top: 42px;
        &.gray{
          background: #dce1e8;
          color: #454545;
          margin-top: 20px;
          margin-left: 0;
        }
      }
    }
    .form{
      .title{
        height: 32px;
        font-size: 24px;
        font-weight: 400;
        color: rgb(23,35,61);
        line-height: 32px;
        text-align: center;
        margin-top: 60px;
      }
      i{
        // width: 24px;
        // height: 24px;
        // position: absolute;
        // right: 16px;
        // top: 12px;
        // color: #212530;
        cursor: pointer;
      }
      .login-close{
        font-size: 22px;
        height: 22px;
        width: 22px;
        line-height: 22px;
        position: absolute;
        right: 12px;
        top: 12px;
        color: #b4b5b9;
        cursor: pointer;
      }
      .login-close-div{
        width: 60px;
        height: 60px;
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
        z-index: 999;
      }
      .form-item--cont{
        padding: 50px 32px 0 32px;
        box-sizing: border-box;
        .error-tips{
          width: 100%;
          height: 22px;
          line-height: 22px;
          color: #E02020;
          font-size:14px;
          margin-top: 15px;
          position: relative;
          box-sizing: border-box;
          text-align: left;
          i{
            left: 0;
            top: 0;
            font-size: 20px;
            color: #FE9B07;
          }
        }
        .input--wrapper{
          position: relative;
          box-sizing: border-box;
          &>*{
            display: inline-block;
          }
          input{
            width: 100%;
            box-sizing: border-box;
            font-size: 16px;
            padding-left: 48px;
            height:48px;
            border-radius:4px;
            border:1px solid rgba(33,37,48,0.15);
            background-color: #fff;
            box-shadow: 0 0 0 2px rgba(255, 255, 255);
            &:hover{
              border:1px solid rgba(32,121,250,1);
            }
            &:focus {
              outline: none;
              border-color: #2079fa;
              box-shadow: 0 0 0 2px rgba(24,144,255,.2);
            }
          }
          i{
            position: absolute;
            left: 12px;
            line-height: 48px;
            font-size: 24px!important;
            color: rgba(33,37,48,0.55);
          }
        }
        .mg-t-24{
          margin-top: 24px;
        }
        .forget-link{
          display: block;
          height:20px;
          margin-top: 28px;
          font-size:14px;
          font-weight:400;
          color:rgba(33,37,48,0.55);
          line-height:20px;
        }
        .foget_password{
          color:rgba(33,37,48,0.55);
        }
        .phone-number-wrapper{
          display: flex;
        }
        .input-mobile-member{
          flex: 1;
          width: 100%;
          font-size: 16px;
          box-sizing: border-box;
          padding-left: 12px;
          height:48px;
          border-radius:4px;
          border:1px solid rgba(33,37,48,0.15);
          background-color: #fff;
          box-shadow: 0 0 0 2px rgba(255, 255, 255);
          border-radius: 0 4px 4px 0;
          &:hover{
            border:1px solid rgba(32,121,250,1);
            z-index: 1;
          }
          &:focus {
            outline: none;
            border-color: #2079fa;
            box-shadow: 0 0 0 2px rgba(24,144,255,.2);
            z-index: 1;
          }
        }
        .input-area-member{
          width: 80px;
          height:48px;
        }
        .verification-input{
          margin-top: 24px;
          box-shadow: 0;
          border-radius: 4px 0 0 4px;
          box-shadow: none;
          font-family: PingFangSC-Regular, PingFang SC !important;
        }
        .verification-button{
          position: relative;
          left: -1px;
          color:rgba(33,37,48,0.8);
          font-size:16px;
          font-weight:400;
          height: 46px;
          box-shadow: none;
          width: 100px;
          margin-top: 24px;
          border-radius: 0 4px 4px 0;
          background: #fff;
          border:1px solid rgba(222,223,224,1);
          &.disabled{
            cursor: not-allowed ;
            background: rgba(33,37,48,0.06);
          }
        }
      }
    }
    .form2{
      // margin-left: 50px;
      >p{
        padding: 0 32px;
      }
      .title{
        font-family: PingFangSC-Light, PingFang SC  !important;
        text-align: left;
        font-weight: 300;
        color: #17233D;
        font-size: 24px;
        margin-top: 48px;
        display: flex;
        i{
          color: #2125308c;
          margin-right: 10px;
          font-weight: 500 !important;
          font-size: 24px !important;
        }
      }
      .describe{
        color: rgba(33, 37, 48, 0.55);
        font-size: 14px;
        line-height: 22px;
        margin-top: 8px;
        font-family: PingFangSC-Regular, PingFang SC  !important;
      }
      .form-item--cont{
        padding: 32px 32px;
        .phone-number-wrapper{
          margin-top: 0 !important;
        }
        .verification-input,.verification-button{
          margin-top: 0;
        }

      }
      .verifyButton{
        margin-top: 70px;
      }
    }
  }

  .safety-dialog-bg{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9999;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .safety-dialog{
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 9999;
    margin-left: -241.5px;
    margin-top: -113.5px;
    width: 483px;
    height: 227px;
    background: transparent url('~@/assets/images/safety.png') 0 0 no-repeat;
    .close{
      color: #2981c1;
      position: absolute;
      top: 17px;
      right: 20px;
      font-size: 14px;
    }
    .safety-content{
      width: 290px;
      font-size: 16px;
      color: #000;
      margin: 65px 0 0 160px;
      text-align: center;
      p {
        text-align: left;
        line-height: 30px;
        margin-bottom: 20px;
      }
      a{
        padding: 0px 30px;
      }
    }

    .ui-btn_lg {
      height: 38px;
      line-height: 38px !important;
      font-size: 14px;
    }
  }
</style>
<script>
import JsEncrypt from 'jsencrypt'
import { getCookie, setCookie, delCookie, deleteAllCookie, aes, appId, captchaId } from '@/assets/utils/CommonUtil'
import { getParams } from '@/assets/utils'
import { mapMutations } from 'vuex'
import userService from '@/assets/service/user'
import LoginService from '@/assets/service/login'

import spaceService from '@/assets/service/space'
import Countdown from '_c/common/countDown'
import {qydataUrl} from '@/assets/js/config'


// rsa加密
const encrypt = new JsEncrypt()
const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDd9v+OVxa5ituKgpeyUVHG6oLd15HJsI6UHj7ZcQsrGTJGzA+Gv0LkPwnHBxyqXnaY8gY98KVBGCE/3gfejdT8a9Wx7n7Iu1xPE35WnYzSZ/TuDVzK3bU8HV/EiiVPXEzJQmhmHMwMzUOJJ3+jGkafad/BVs8Pysxdd3uUWkInuQIDAQAB'

// 网易易盾
let captchaIns
// 兼容IE10
if (window['context'] === undefined) {
  if (!window.location.origin) {
    window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
  }
  window['context'] = location.origin + '/V6.0'
}
if (!window.location.origin) {
  window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
}
let urlDomain = window.location.origin

export default {
  name: 'LoginBox',
  data () {
    return {
      isDoubleVerify: false, // 二次验证
      qydataUrl,
      toggleLoginType: false,
      fetchingMobile: false,
      mobileLoginLoading: false,
      user: {},
      totalCapacity: 0,
      usedCapacity: 0,
      percentage: 0,
      form: {
        userName: '',
        password: '',
        area: '',
        areaCode: '+86',
        mobile: '',
        verification: '',
        timer: 0,
        mobileSucceed: false,
        list: []
        // {"code":200,"message":null,"data":{"sign":"5776891a-c85c-43be-a187-75288c4e061e","accountList":[{"id":"6669168159307424547","fullname":"aaa1@003","username":"aaa1@003","mobile":null,"createTime":"1590053596000","passwordMobile":"18259403404","roleId":4,"roleName":"普通成员","enterpriseId":"6097213048518832145","enterpriseName":"造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静abcd1234"},{"id":"6675558471377203772","fullname":"ker01@003","username":"ker01@003","mobile":null,"createTime":"1591577165000","passwordMobile":"18259403404","roleId":4,"roleName":"普通成员","enterpriseId":"6097213048518832145","enterpriseName":"造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静abcd1234"},{"id":"6676063960816767756","fullname":"ker02@003","username":"ker02@003","mobile":null,"createTime":"1591697684000","passwordMobile":"18259403404","roleId":4,"roleName":"普通成员","enterpriseId":"6097213048518832145","enterpriseName":"造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静abcd1234"},{"id":"6676301753037271777","fullname":"ker03@003","username":"ker03@003","mobile":null,"createTime":"1591754378000","passwordMobile":"18259403404","roleId":4,"roleName":"普通成员","enterpriseId":"6097213048518832145","enterpriseName":"造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静abcd1234"},{"id":"6729314877276230618","fullname":"18259403404@广联达","username":"18259403404@广联达","mobile":null,"createTime":"1604393691000","passwordMobile":"18259403404","roleId":4,"roleName":"普通成员","enterpriseId":"6537227414530929606","enterpriseName":"广联达造价UXD"},{"id":"6729568594295103539","fullname":"18259403404@003","username":"18259403404@003","mobile":null,"createTime":"1604454182000","passwordMobile":"18259403404","roleId":4,"roleName":"普通成员","enterpriseId":"6097213048518832145","enterpriseName":"造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静造价云王静abcd1234"},{"id":"6731841861668307184","fullname":"18259403404@xncs","username":"18259403404@xncs","mobile":null,"createTime":"1604996171000","passwordMobile":"18259403404","roleId":4,"roleName":"普通成员","enterpriseId":"6649126851930157593","enterpriseName":null},{"id":"6503801922482876710","fullname":"4529e5f59bd2ba2e","username":"4529e5f59bd2ba2e","mobile":"18259403404","createTime":"1550627213000","passwordMobile":"18259403404","roleId":5,"roleName":"个人账号","enterpriseId":null,"enterpriseName":null},{"id":"6653219403168801710","fullname":"kerong","username":"kerong","mobile":null,"createTime":"1586251117000","passwordMobile":"18259403404","roleId":5,"roleName":"个人账号","enterpriseId":null,"enterpriseName":null}]}}
      },
      verifyForm: {
        verification: '',
        timer: 0
      },
      isDisabled: false, // 是否开始倒计时
      phone: null, // 登陆之后的手机号
      fetching: false, // 正在登陆 ...
      loginError: '',
      loginVerifyError: '', // 双因素验证错误提示
      safetyDialogShow: false, // 显示密码安全等级较低弹窗
      safetyLink: '' // 跳转到 用户中心修改密码的地址(登录 code: 200018 时 返回data值 )
    }
  },
  props: {
    loginType: {
      type: String,
      default: 'phone'
    },
    resetMarginTop: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Countdown
  },
  computed: {
    // 登录用户 空间使用量信息
    userSpaceDes () {
      const obj = {}
      let title = '个人空间容量'
      let capacity = this.usedCapacity + 'M/' + this.totalCapacity + 'M'
      if (+this.user.userType === 1) {
        title = '员工空间使用量'
        capacity = this.usedCapacity + 'G'
      }
      if (+this.user.userType === 3) {
        title = '企业空间容量'
        capacity = this.usedCapacity + 'G/' + this.totalCapacity + 'G'
      }
      obj.title = title
      obj.capacity = capacity
      return obj
    },
    // 判断是否符合手机格式
    isMobile () {
      let reg = /^1[3456789]{1}\d{9}$/
      return reg.test(this.form.mobile)
    }
  },
  watch: {
    // 设置登录类型
    loginType: {
      handler (value) {
        if (value === 'account') {
          this.toggleLoginType = true
        }
      },
      immediate: true
    },
    toggleLoginType: function (){
      this.form.areaCode = '+86'
      this.form.mobile = ''
      this.form.verification = ''
      this.form.timer = 0
      this.form.mobileSucceed = false
      this.form.list = []
      this.loginError = ''
      if (!this.toggleLoginType) {
        this.sentLog(100101046)
      }
    },
    isDoubleVerify (){
      this.verifyForm.timer = 0
      this.verifyForm.verification = ''
      this.loginVerifyError = ''
    }
  },
  created () {
    this.getLoggedUserInfo()
    this.fetching = false
  },
  methods: {
    ...mapMutations({
      setUserInfo: 'user/SET_USERINFO'
    }),
    // 1. 获取已登录用户信息
    getLoggedUserInfo () {
      let userInfo = getCookie('ZJYUSERINFO')
      if (userInfo && !this.$route.query.willLogin){
        // 用户处于登录状态
        userInfo = JSON.parse(userInfo)
        this.user = userInfo
        if (this.user.userType){
          let workspaceId = ''
          if (+this.user.userType === 1){
            workspaceId = getCookie('enterpriseWorkspaceIdValue')
          }
          if (+this.user.userType === 2){
            workspaceId = getCookie('personalWorkspaceIdValue')
          }
          if (+this.user.userType === 3){
            workspaceId = getCookie('personalWorkspaceIdValue')
          }
          if (!workspaceId) return
          spaceService.getWorkspaceById({ workspaceId: workspaceId }).then(data => {
            if (+data.code === 200) {
              // let str = 'company';
              // 企业员工 空间使用量 单位为G
              let unit = 1024 * 1024 * 1024
              if (this.user.userType === 2) {
                // 个人账号 空间使用量 单位为M
                unit = 1024 * 1024
              }
              let { totalCapacity, usedCapacity } = data.data

              totalCapacity = Math.abs(+totalCapacity / unit)
              // usedCapacity = (+usedCapacity / unit)
              //   .toFixed(2)
              //   .replace(/[0]+$/, "")
              //   .replace(/\.$/, "");
              // usedCapacity = parseFloat(usedCapacity);
              usedCapacity = (+usedCapacity / unit)
              if (usedCapacity < 0.01){
                usedCapacity = 0
              } else {
                usedCapacity = usedCapacity.toFixed(2)
              }
              let percentage = (usedCapacity / +totalCapacity * 100)
                .toFixed(2)
                .replace(/[0]+$/, '')
                .replace(/\.$/, '')
              percentage = parseFloat(percentage)
              this.totalCapacity = totalCapacity
              this.usedCapacity = usedCapacity
              this.percentage = percentage
            }

          })
        }
      } else {
        if (this.$route.query.willLogin) {
          this.logout()
        }
        // 未登录状态时
        this.$set(this.form, 'userName', getCookie('ZJYACCOUNT'))
        let time = 10
        // 若cookie 里面有 管理员账号则 填充管理员账号
        const adminCount = getCookie('ADMIN_COUNT_HIT')
        if (adminCount) {
          this.toggleLoginType = true
          time = 1000
          this.$set(this.form, 'userName', adminCount)
          delCookie('ADMIN_COUNT_HIT')
        }
        setTimeout(() => {
          const indexPagePassword = document.getElementById('indexPagePassword')
          if (indexPagePassword) {
            indexPagePassword.type = 'password'
          }
        }, time)
      }
    },
    // 1.1 获取短信登录验证吗
    getVerification () {
      let reg = /^1[3456789]{1}\d{9}$/
      if (!reg.test(this.form.mobile) || this.form.timer > 0){
        return
      }
      captchaIns && captchaIns.verify()
    },
    // 1.2 网易易盾验证成功回调
    verifyCallback (verifyOptions = {}) {
      let that = this
      let {postfix = '', showAddMember = false, uploadVisible = false, memberInfo = {}, isEditor = false} = that
      let suffix = `@${postfix}`
      captchaIns && captchaIns.refresh()
      // 获取短信
      let time = new Date().getTime()
      let query = {
        appId,
        sign: aes(time, this.form.mobile),
        t: time
      }
      let params = {
        captchaCode: verifyOptions.validate,
        captchaId,
        mobile: this.form.mobile
      }
      LoginService.getMobileCode(query, params).then((res) => {
        console.log(res)
        if (res.code === 200) {
          this.form.timer = 60
        } else {
          this.$message.error(res.message || '获取验证码失败')
        }
      }).catch((e) => {
        this.$message.error('获取验证码失败')
      })
    },
    // 1.3 网易易盾初始化
    initNECaptchaDom () {
      let that = this
      window.initNECaptcha({
        element: this.$refs.captcha, // 验证码容器元素ID
        captchaId, // 由用户中心分配
        mode: 'bind',
        width: '320px',
        onVerify (err, data) {
          // 用户验证码验证成功后，进行实际的提交行为
          if (data) {
            that.verifyCallback({validate: data.validate, captchaId})
          }
        }
      }, instance => {
        // 初始化成功后得到验证实例instance，可以调用实例的方法
        captchaIns = instance
      }, err => {
        // 初始化失败后触发该函数，err对象描述当前错误信息
        console.log(err)
      })
    },
    // 2. 登录
    submitForm () {
      deleteAllCookie({}, document.domain)
      if (this.toggleLoginType) {
        this.submitAccountForm()
      } else {
        this.submitMobileForm()
      }
    },
    // 双因素验证---倒计时结束
    countFinis (){
      this.verifyForm.timer = 0
      this.isDisabled = false
    },
    // 双因素验证---获取手机验证码验证
    getDoubleVerification (mobile){
      if (this.verifyForm.timer !== 0){ // 如果还在倒计时，不获取验证码
        return false
      }
      this.loginVerifyError = ''
      let time = new Date().getTime()
      let query = {
        mobile,
        appId,
        sign: aes(time, mobile),
        t: time
      }
      LoginService.fetchVerifyCode(query).then(res => {
        console.log(res)
        if (res.code === 200){
          this.isDisabled = true
          this.verifyForm.timer = 60
        } else {
          this.loginVerifyError = res.message
        }

      })
    },
    // 双因素验证---手机验证码验证
    verifyCode (){
      if (this.verifyForm.verification !== ''){
        LoginService.verifyCode(this.phone, this.verifyForm.verification).then(res => {
          if (res.code === 200){
            this.getWorkSpaceList(getCookie('role'))
          } else {
            this.loginVerifyError = '验证失败！'
          }
        })
      } else {
        this.loginVerifyError = '请输入验证码！'
      }
    },
    // 双因素验证---关闭
    closeVerify (){
      this.isDoubleVerify = false
      this.logout()
    },
    // 2. 登录成功回调
    loginSuccess (data) {
      if (this.toggleLoginType) {
        // 登录账号 记录在cookie 里 下次进到登录页 自动填入
        setCookie('ZJYACCOUNT', this.form.userName)
      }
      deleteAllCookie({'ZJYACCOUNT': true})
      if (data.data && data.data.grayDomain) {
        // 调整为通用
        let grayDomain = data.data.grayDomain
        urlDomain = grayDomain.includes('test') ? 'https://zjytest-gray.glodon.com' : grayDomain.includes('pre') ? 'https://zjy-gray-pre.glodon.com' : 'https://zjy-gray.glodon.com'
        setCookie('grayMenuDomain', grayDomain.replace('http://', '').replace('https://', ''))
        // 解决计价灰度冲突
        // let grayDomain = data.data.grayDomain
        // if (grayDomain === 'http://deco.glodon.com') {
        //   urlDomain = 'https://zjy-gray.glodon.com'
        //   setCookie('grayMenuDomain', 'deco.glodon.com')
        // } else if (grayDomain === 'http://deco-pre.glodon.com') {
        //   urlDomain = 'https://zjy-gray-pre.glodon.com'
        //   setCookie('grayMenuDomain', 'deco-pre.glodon.com')
        // } else {
        //   urlDomain = grayDomain
        // }
        // 原有灰度设置
        // urlDomain = data.data.grayDomain
      }
      switch (+data.code) {
        case 200:
          this.loginError = ''
          setCookie('role', data.data.role)
          setCookie('gldToken', data.data.gldToken)
          setCookie('gldUserId', data.data.gldUserId)
          setCookie('ZJYTOKEN', data.data.token)
          setCookie('ZJYUSERINFO', JSON.stringify(data.data))
          setCookie('LOGINREGION', data.data.area)
          if (data.data.geipToken) {
            setCookie('GEIPTOKEN', data.data.geipToken)
            setCookie('tenantId', data.data.tenantId)
            setCookie('orgId', data.data.rootOrgId)
            this.setCurrentTopUrl()
          }
          this.setUserInfo(data.data)
          window.ZJYUSERINFO = JSON.stringify(data.data)
          let userType = data.data.userType
          this.phone = data.data.passwordMobile

          if ([1, 6].includes(data.data.role) && this.phone){ // 管理员或者审计员登录
            console.log('管理员或审计员登录')
            LoginService.isDoubleVerify(this.phone).then(res => {
              if (res.code === 200){
                if (res.data){ // 需要二次验证
                  this.isDoubleVerify = true
                  this.getDoubleVerification(this.phone)
                } else { // 不需要二次验证
                  this.getWorkSpaceList(userType)
                }

              } else {

              }
            })

          } else {
          // this.loginSuccess(data)
            this.getWorkSpaceList(userType)
          }
          // this.getWorkSpaceList(userType)
          break
        case 200002:
          this.loginError = '用户名或密码错误，请重新输入'
          this.form.password = ''
          break
        case 200003:
          this.loginError = '用户中心连接异常'
          break
        case 200018:
          this.safetyDialogShow = true
          this.safetyLink = data.data
          this.loginError = '管理员账号不允许使用初始密码登录'
          break
        case 200019:
          this.loginError = '管理员必须绑定密保手机或邮箱'
          break
        case 200036:
          this.loginError = '用户已被锁定'
          break
        case 200016:
          this.loginError = '当前租户无产品授权，请前往体验中心领取后使用'
          const accountToken = data.data
          window.open(`#/free-license?token=${accountToken}`)
          break
        default:
          this.loginError = '登录失败'
          console.dir(data.message)
      }
      if (this.loginError) {
        if (this.toggleLoginType){
          this.sentLog(100101036, {message: this.loginError, userName: this.form.userName})
        } else {
          this.sentLog(100101047, {message: this.loginError, phone: this.form.mobile})
        }
        // this.sentLog(this.toggleLoginType ? 100101036 : 100101047, {message: this.loginError})
      }
    },
    // 2. 账号密码登录
    submitAccountForm () {
      if (this.fetching) return
      if (this.form.userName === '' || this.form.password === '') {
        this.loginError = '请输入用户名和密码'
        return
      }
      if (window.province) {
        this.form.area = window.province
      }
      let formData = {
        userName: this.form.userName,
        password: encodeURIComponent(this.form.password),
        area: this.form.area
      }
      encrypt.setPublicKey(publicKey)
      formData.userName = formData.userName.trim()
      formData.password = encrypt.encrypt(formData.password)
      this.fetching = true
      LoginService.login(formData).then((data) => {
        this.fetching = false
        this.loginSuccess(data)
      }).catch((e) => {
        this.loginError = '登录失败'
        this.sentLog(this.toggleLoginType ? 100101036 : 100101047, {message: '500，服务器异常'})
        this.fetching = false
      }).finally(() => {
        this.fetching = false
      })
    },
    // 2. 短信快捷登录
    submitMobileForm () {
      if (this.fetchingMobile) return
      if (this.form.mobile === '') {
        this.loginError = '请输入手机号'
        this.sentLog(100101047, {message: this.loginError})
        return
      }
      if (this.form.verification === '') {
        this.loginError = '请输入短信验证码'
        this.sentLog(100101047, {message: this.loginError})
        return
      }
      let params = {
        verifyCode: this.form.verification,
        mobile: this.form.mobile
      }
      this.fetchingMobile = true
      this.form.list = []
      LoginService.getMobileAccount(params).then(({code, data = {}, message = ''}) => {
        this.fetchingMobile = false
        if (code === 200) {
          this.form.sign = data.sign
          if (data.accountList && (data.accountList.length > 1 || data.accountList.length === 0)) {
            this.form.list = data.accountList
            this.form.mobileSucceed = true
          } else {
            this.mobileLogin(data.accountList[0])
          }
        } else {
          this.loginError = message || '获取关联账号失败'
          this.sentLog(100101047, {message: this.loginError})
        }
      }).catch((e) => {
        this.fetchingMobile = false
        this.loginError = '获取关联账号失败'
        this.sentLog(100101047, {message: this.loginError})
      })
    },
    // 2. 注册手机号并登录
    signMobile () {
      let params = {
        verifyCode: this.form.verification,
        mobile: this.form.mobile
      }
      LoginService.mobileFastReg(params).then(({code, data = {}, message = ''}) => {
        if (code === 200) {
          this.form.sign = data.sign
          this.mobileLogin(data.accountInfo)
        } else {
          this.$message.error(message || '注册手机号失败')
        }
      }).catch((e) => {
        this.$message.error('注册手机号失败')
      })
    },
    // 2. 关联账号登录
    mobileLogin (item) {
      let params = {
        sign: this.form.sign
      }
      this.mobileLoginLoading = true
      LoginService.loginById(item.id, params).then((res) => {
        this.mobileLoginLoading = false
        console.log(res)
        if (res.code === 200 || res.code === 200016) {
          this.loginSuccess(res)
        } else {
          this.$message.error(res.message || '登录失败')
          this.sentLog(100101047, {message: res.message || '登录失败'})
        }
      }).catch((e) => {
        this.mobileLoginLoading = false
        this.$message.error('登录失败')
        this.sentLog(100101047, {message: '登录失败'})
      })
    },
    // 2.1 获取登录用户的 空间列表
    getWorkSpaceList (userType){
      LoginService.getWorkSpaceList().then((res) => {
        // 220026 新添加的员工首次登陆 接口会提示查询员工空间失败
        if (+res.code === 200){
          res.data.map((item) => {
            switch (item.type){
              case 1:
                setCookie('personalWorkspaceIdValue', item.id)
                break
              case 2:
                setCookie('enterpriseWorkspaceIdValue', item.id)
                break
              case 3:
                setCookie('projectWorkspaceIdValue', item.id)
                break
              default:
            }
          })
          this.goPage(userType)
        } else {
          if (this.toggleLoginType) {
            this.loginError = '登录失败'
          } else {
            this.$message.error('登录失败')
          }
          this.sentLog(this.toggleLoginType ? 100101036 : 100101047, {message: '空间列表获取失败'})
        }

      })

    },
    // 2.2 调用登录接口成功后 预跳转到指定页面 or 登录用户点击 “进入造价云管理平台” 时
    goPage (userType, logged){
      // 在两个页签 一个页签 用户已退出时 点击 进入进入造价云管理平台  时 刷新页面
      const zjyToken = getCookie('ZJYTOKEN')
      const zjyUserInfo = getCookie('ZJYUSERINFO')
      if (!zjyToken || !zjyUserInfo) {
        window.location.reload()
      }
      if (!userType){
        userType = this.user.userType
      }
      const query = this.$route.query
      if (query && query.fromPath) {
        // 若是从某个页面 登录超时 后 跳转到登录页则登录后 直接跳转到之前页面
        const fromPath = decodeURIComponent(query.fromPath)
        if (/^http[s]?:\/\//.test(fromPath)) {
          // 要先去用户中心单点登录
          // window.location.href = fromPath
          this.singleLogin(fromPath, userType, logged)
        } else {
          // this.$router.push({
          //   path: fromPath
          // })
          const preUrl = `${urlDomain}/#${fromPath}`
          this.singleLogin(preUrl, userType, logged)
        }
      } else {
        this.singleLogin(`${urlDomain}/#/home`, userType, logged)
      }
    },
    // 2.3 单点登录
    singleLogin (path, userType, logged){
      LoginService.singleLogin({
        redirectUrl: path
      }).then((res) => {
        if (+res.code === 200){
          try {
            const params = getParams(res.data)
            const targetUrl = decodeURIComponent(params.target_url)
            const grayReg = /^http[s]?:\/\/[^-.]+-gray[^.]*\.glodon.com/
            if (grayReg.test(targetUrl)) {
              // 登录用户能访问 灰度域名
              setCookie('canVisitGray', 'true')
            } else {
              delCookie('canVisitGray')
            }
          } catch (e) {
            console.log(e)
          }
          sessionStorage.removeItem('privacyShow')
          this.sentLog(100101037, {type: userType, way: this.toggleLoginType ? 1 : 2, role: this.user.role})
          window.location.href = res.data
          return
        } else {
          if (logged) {
            deleteAllCookie()
            window.location.href = `${urlDomain}`
          }
        }
        if (this.toggleLoginType) {
          this.loginError = '登录失败'
        } else {
          this.$message.error('登录失败')
        }
        this.sentLog(this.toggleLoginType ? 100101036 : 100101047, {message: '用户中心单点登录失败'})
      }).catch((e) => {
        if (this.toggleLoginType) {
          this.loginError = '登录失败'
        } else {
          this.$message.error('登录失败')
        }
        this.sentLog(this.toggleLoginType ? 100101036 : 100101047, {message: '500，服务器异常'})
      })
      // window.location.href = `${urlDomain}/#/home`
    },
    // 3.1 密码安全等级较低 弹窗关闭
    safetyDialogClose (){
      this.safetyDialogShow = false
    },
    // 3.2 密码安全等级较低 去用户中心修改密码
    safetyLinkTap (){
      this.safetyDialogShow = false
      setTimeout(() => {
        window.open(this.safetyLink)
      }, 200)
    },
    // 4. 退出 造价云管理平台内的退出是去 用户中心退出并未调用 backend 的退出
    logout () {
      const token = getCookie('GEIPTOKEN') || getCookie('ZJYTOKEN')
      if (token){
      // 退出backend
        userService.logout().then(data => {
          
        })
      }
      deleteAllCookie({'ADMIN_COUNT_HIT': true})
      deleteAllCookie({'ADMIN_COUNT_HIT': true}, '.glodon.com')
      this.setUserInfo({})
      this.user = {}
    },
    // 当时zjytest域名下时存储当前url，用于区分环境，因为ae环境对应了zjytest和zjy-pre两个环境
    setCurrentTopUrl () {
      const hrefReg = /^http[s]?:\/\/([^/:]+)/
      const origin = hrefReg.exec(window.location.href)
      const regAe = new RegExp('^' + 'zjytest')
      setCookie('currentTopUrl', null)
      console.log(origin)
      if (regAe.test(origin[1])) {
        setCookie('currentTopUrl', origin[0])
      }
    }
  },
  mounted () {
    this.initNECaptchaDom()
  }
}
</script>
